import {assert} from 'Asserts';
import {TagTypesByName, TagType} from 'file-browser/FileBrowserUtil';
import {FIELD_TYPES} from 'schemas/fields/SchemaFieldConstants';
import {OptionData} from 'ui-library/menus/MenuConstants';

function isUneditableSchemaField(tagInfo: TagType): boolean | undefined {
  return tagInfo.isComputed || tagInfo.isSnapshot || tagInfo.isConvertedFromLink;
}

function getUneditableSchemaFieldTypeName(tagInfo: TagType): string {
  if (tagInfo.isComputed) {
    return 'computed';
  } else if (tagInfo.isSnapshot) {
    return 'snapshot';
  }
  assert(tagInfo.isConvertedFromLink!, 'Schema field is expected to be uneditable.');
  return 'converted from';
}

export default function getOptionDataFromTag(tagNamesAndTypes: TagTypesByName, tagName: string): OptionData {
  const tagInfo = tagNamesAndTypes[tagName];
  const tagType = tagInfo.type;
  const standardOption = {name: tagName, value: tagName};
  if (!tagType) {
    // custom tag
    return standardOption;
  }

  if (isUneditableSchemaField(tagInfo)) {
    const text = `${tagName}: Cannot edit ${getUneditableSchemaFieldTypeName(tagInfo)} fields`;
    return {
      name: text,
      disabled: true,
      value: text,
    };
  }

  let disabledText;
  switch (tagType.type) {
    case FIELD_TYPES.AA_PART_LINK.type:
    case FIELD_TYPES.PART_LINK.type:
    case FIELD_TYPES.TRANSLATION_LINK.type:
      disabledText = `${tagName}: ${tagType.label}s not supported`;
      return {
        name: disabledText,
        disabled: true,
        value: disabledText,
      };
    default:
      return standardOption;
  }
}
